import type { ReactNode } from "react";
import { Card } from "../../components/ui";

export function AuthLayout({ title, subtitle, children }: { title: string; subtitle?: string; children: ReactNode }) {
  return (
    <main className="flex min-h-screen items-center justify-center px-4 py-10">
      <Card className="w-full max-w-sm p-6">
        <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-gold-700">
          Portal de cumplimiento PLD/FT
        </p>
        <h1 className="mb-1 text-lg font-semibold text-gray-900">{title}</h1>
        {subtitle && <p className="mb-4 text-sm text-gray-500">{subtitle}</p>}
        <div className={subtitle ? undefined : "mt-4"}>{children}</div>
      </Card>
    </main>
  );
}
